const Common = {
  devIps:['210.96.184.249', '127.0.0.1', '172.17.0.1', '192.168.0.1', '192.168.1.4' ],
  isProduction: function() {
    return (process.env.NODE_ENV === 'production');
  },
  
};

export default Common;